import { customToast } from "../../../../shared";
import { surveyQueuesServices } from "../../services";
import { success, withSpinner } from "../../../../redux/actions/utilities";
import {
  toastTypes,
  errorMessages,
  successMessages,
  surveyQueuesConstants,
} from "../../constants";

const { GET_SURVEY_QUEUES, SEND_EMAIL_MESSAGE } = surveyQueuesConstants;

//Fetching survey queues paginated data
const getSurveyQueues = (body) => {
  return (dispatch) => {
    withSpinner(dispatch, GET_SURVEY_QUEUES, () =>
      surveyQueuesServices
        .getSurveyQueues(body)
        .then(
          (response) => {
            dispatch(success(response, GET_SURVEY_QUEUES));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
          }
        )
    );
  };
};

// Sending email message
const sendEmailMessage = (emailId, callBackFunc) => {
  return (dispatch) => {
    withSpinner(dispatch, SEND_EMAIL_MESSAGE, () =>
      surveyQueuesServices
        .sendEmailMessage(emailId)
        .then(
          (response) => {
            customToast(
              successMessages.EMAIL_SUCCESSFULLY_SENT,
              toastTypes.SUCCESS
            );
            dispatch(success(response, SEND_EMAIL_MESSAGE));
            callBackFunc();
          },
          (error) => {
            const errorMessage = error[0] || errorMessages.EMAIL_SENDING_FAILED;
            customToast(errorMessage, toastTypes.ERROR);
          }
        )
    );
  };
};

export const surveyQueuesActions = {
  getSurveyQueues,
  sendEmailMessage,
};
